import React, { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { useLocation } from "react-router";
import { productViewData } from "services/apiService";
import "styles/ProductView.css";
import config from "config";

const ProductView: React.FC = () => {
  const [productViewdata, setProductViewdata] = useState(null);
  const location = useLocation();
  const { product_id } = location.state || {};
  const AppUrl = config?.REACT_APP_IMAGE_URL;

  useEffect(() => {
    getProductViewData();
  }, [product_id]);

  const getProductViewData = async () => {
    const response = await productViewData(product_id);
    setProductViewdata(response?.data);
  };

  if (!productViewdata) {
    return (
      <div className="loading-spinner">
        <CircularProgress />
      </div>
    );
  }

  return (
    <div className="product-view-container container-fluid">
      <div className="row">
        <div className="col-lg-6 col-md-12">
          <div className="image-grid-view">
            {productViewdata.ProductMedia?.map((media, index) => (
              <div key={media.product_asset_id} className="image-grid-item">
                <img
                  src={`${AppUrl}${media.product_image}`}
                  alt={`Asset ${index + 1}`}
                  className="grid-image"
                />
              </div>
            ))}

            <div className="image-grid-item">
              <img
                src={`${AppUrl}${productViewdata.thumnail_image}`}
                alt={productViewdata.product_name}
                className="grid-image"
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-12 product-details">
          <h2 className="product-name">{productViewdata.product_name}</h2>
          <br />
          <p className="product-price" style={{ color: "#4093d2" }}>
            ₹{productViewdata.original_price}
            <span className="sales-price">₹{productViewdata.sales_price}</span>
          </p>

          <p>
            <strong>Brand:</strong> {productViewdata.brand_name}
          </p>
          <p>
            <strong>Category:</strong> {productViewdata.category_name}
          </p>
          <p>
            <strong>Quantity:</strong> {productViewdata.quantity}
          </p>
          <p>
            <strong>Tax:</strong> {productViewdata.tax_name} (
            {productViewdata.tax_percentage}%)
          </p>
          <p>
            <strong>Status:</strong>{" "}
            <span
              style={{
                color: productViewdata.is_active ? "green" : "red",
              }}
            >
              {productViewdata.is_active ? "Active" : "Inactive"}
            </span>
          </p>
          <hr />
          <p className="product-description">
            <strong>Description:</strong> <br />
            <br />
            <span
              style={{ color: "grey" }}
              dangerouslySetInnerHTML={{
                __html: productViewdata.description,
              }}
            />
          </p>
          <hr />
          <p className="product-specification">
            <strong>Specifications:</strong>
            <br />
            <br />
            <span
              style={{ color: "grey" }}
              dangerouslySetInnerHTML={{
                __html: productViewdata.specification,
              }}
            />
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProductView;
